import { inject, Injector } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { STORAGE_SERVICE_TOKEN } from '@/core/util/storage.token';
import { AppI18nService } from '@/core/service/app-i18n-service';
import { TokenRefreshCoordinator } from '@/core/interceptor/token-refresh-coordinator.service';
import { STORAGE_KEYS } from '@/share/constant/storage_token.key';

/**
 * DIP: depends on injected services, not on concrete AuthService.
 * The 401-refresh logic is fully delegated to TokenRefreshCoordinator,
 * which holds isRefreshing/queue as class-level fields (fixing the stale-closure bug).
 */
export const HttpClientInterceptor: HttpInterceptorFn = (
    req: HttpRequest<any>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
    const storage     = inject(STORAGE_SERVICE_TOKEN);
    const i18n        = inject(AppI18nService);
    const injector = inject(Injector); // use injector instead of direct service
    // Attach Accept-Language and Bearer token
    let authReq = req.clone({
        setHeaders: { 'Accept-Language': i18n.currentLang() }
    });
    if (storage.get(STORAGE_KEYS.TOKEN)) {
        authReq = authReq.clone({
            setHeaders: { Authorization: `Bearer ${storage.get(STORAGE_KEYS.TOKEN)}` }
        });
    }

    return next(authReq).pipe(
        catchError((error) => {
            if (error.status === 401) {
                const coordinator = injector.get(TokenRefreshCoordinator);
                return coordinator.handle(authReq, next);
            }
            return throwError(() => error);
        })
    );
};
